import { createAction, handleActions } from "redux-actions";

const SET = 'mathjax.SET';
const CLEAR = 'mathjax.CLEAR';

const defaultState = {
  target : null,
  renderKey : {}
};

const setMathJaxAction = createAction( SET, payload => payload );
const clearMathJaxAction = createAction( CLEAR );

const mathjax = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ CLEAR ] : () => defaultState
}, defaultState );

export default mathjax;
export { setMathJaxAction, clearMathJaxAction };
